export default __webpack_public_path__ + "static/media/polygon-matic-logo.963376d1.svg";